var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3C5.7835 3 5 3.80589 5 4.8V19.2C5 20.1941 5.7835 21 6.75 21H17.25C18.2165 21 19 20.1941 19 19.2V4.8C19 3.80589 18.2165 3 17.25 3H6.75ZM6.75 4.8L17.25 4.8V19.2H6.75V4.8ZM9.375 7.5C8.89175 7.5 8.5 7.90294 8.5 8.4C8.5 8.89706 8.89175 9.3 9.375 9.3H11.125C11.6082 9.3 12 8.89706 12 8.4C12 7.90294 11.6082 7.5 11.125 7.5H9.375ZM8.5 12C8.5 11.5029 8.89175 11.1 9.375 11.1H12.875C13.3582 11.1 13.75 11.5029 13.75 12C13.75 12.4971 13.3582 12.9 12.875 12.9H9.375C8.89175 12.9 8.5 12.4971 8.5 12ZM9.375 14.7C8.89175 14.7 8.5 15.1029 8.5 15.6C8.5 16.0971 8.89175 16.5 9.375 16.5H14.625C15.1082 16.5 15.5 16.0971 15.5 15.6C15.5 15.1029 15.1082 14.7 14.625 14.7H9.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3C5.7835 3 5 3.80589 5 4.8V19.2C5 20.1941 5.7835 21 6.75 21H17.25C18.2165 21 19 20.1941 19 19.2V4.8C19 3.80589 18.2165 3 17.25 3H6.75ZM6.75 4.8L17.25 4.8V19.2H6.75V4.8ZM9.375 7.5C8.89175 7.5 8.5 7.90294 8.5 8.4C8.5 8.89706 8.89175 9.3 9.375 9.3H11.125C11.6082 9.3 12 8.89706 12 8.4C12 7.90294 11.6082 7.5 11.125 7.5H9.375ZM8.5 12C8.5 11.5029 8.89175 11.1 9.375 11.1H12.875C13.3582 11.1 13.75 11.5029 13.75 12C13.75 12.4971 13.3582 12.9 12.875 12.9H9.375C8.89175 12.9 8.5 12.4971 8.5 12ZM9.375 14.7C8.89175 14.7 8.5 15.1029 8.5 15.6C8.5 16.0971 8.89175 16.5 9.375 16.5H14.625C15.1082 16.5 15.5 16.0971 15.5 15.6C15.5 15.1029 15.1082 14.7 14.625 14.7H9.375Z",
    fill: "#4F6FFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetIcon);
export default __webpack_public_path__ + "static/media/asset-icon.465d3cada5c2f47c865d959f8281ba25.svg";
export { ForwardRef as ReactComponent };